// Model.js
// -----------------------
// @module Case
define("Ames.StoreEventsCalendar.StoreEventsCalendar.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/StoreEventsCalendar/SuiteScript2/StoreEventsCalendar.Service.ss"
            ),
            true
        )
});
});
